import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { AuthSwitch } from '../data';
import { actionSignout } from '../data/auth';

class SignOutRaw extends Component {
  componentWillMount() {
    this.props.signOut();
  }

  render() {
    return (
      <AuthSwitch>
        <Redirect to='/'/>
        <div>
          Signin Out...
        </div>
      </AuthSwitch>
    )
  };
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  signOut: () => actionSignout()
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignOutRaw);



// WEBPACK FOOTER //
// ./src/pages/SignOut.js